// extracted by mini-css-extract-plugin
export default {"point-pop":"PointPop_point-pop__byuBy","info":"PointPop_info__itQcC","header":"PointPop_header__ynBFt","progress":"PointPop_progress__hmUDR","buttons":"PointPop_buttons__Gby76"};